import { defineComponent } from 'vue';
// NOTE: the component using this should have a `form` property of type EASForm
export default defineComponent({
  data() {
    return {
      autocompleteResult: [],
      cachedAutocompleteInput: null,
      selectAddressHandler: '',
      addressErrorMessage: '',
      addressSuggestions: [],
      ignoreAutocomplete: false,
      cachedAddresses: {}
    };
  },
  methods: {
    onAutoCompleteInput(address) {
      this.form.address.street_one = address;
      if (this.cachedAutocompleteInput === address) {
        return;
      }
      if (!address.trim().length) {
        return;
      }
      this.$axios.post('/api/smarty/autocomplete-address', {
        partialAddress: address
      }).then(({
        data
      }) => {
        if (!data) {
          this.autocompleteResult = [];
          return;
        }
        this.autocompleteResult = data.result;
      }).catch(err => {
        this.$sentry.captureException(err);
      });
    },
    onSelectAddressHandler(address) {
      if (this.ignoreAutocomplete) {
        return;
      }
      this.cachedAutocompleteInput = this.form.address.street_one;
      this.form.address.street_one = address.streetLine;
      this.form.address.street_two = address.secondary;
      this.form.address.city = address.city;
      this.form.address.state = address.state;
      this.form.address.zip_code = address.zipcode;
      this.autocompleteResult = [];
    },
    clearAddressModal() {
      this.addressErrorMessage = '';
    },
    addressCorrectionSelected(address) {
      this.ignoreAutocomplete = true;
      this.form.address.street_one = address.deliveryLine1;
      this.form.address.street_two = address.deliveryLine2;
      this.form.address.city = address.components.cityName;
      this.form.address.state = address.components.state;
      this.form.address.zip_code = address.components.zipCode;
      this.cachedAddresses[address.deliveryLine1] = {
        ...this.form.address
      };
      this.addressSuggestions = [];
      this.ignoreAutocomplete = false;
    }
  }
});